// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1hqHs","inner":"Footer_inner__Ghzbh","nextIcon":"Footer_nextIcon__10k_8","innerLeft":"Footer_innerLeft__UqZ02"};